import NoticeContainer from './NoticeContainer';

export default NoticeContainer;
